module.exports = __webpack_public_path__ + "img/kada.7dbb236e.png";